import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"
const DevolucionRendicionIngresosPublicosGridModal = ({ idDevolucionRendicionLote, onCancel }) => {

    const { setIsLoading } = useManagedContext()

    const [rendiciones, setRendiciones] = useState([])
    const [reciboPublicacion, setReciboPublicacion] = useState(null)

    useEffect(() => {
        if (idDevolucionRendicionLote > 0) {
            SearchRendiciones(idDevolucionRendicionLote)
        }
    }, [])

    const SearchRendiciones = (id) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${id}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_INGRESOS_PUBLICOS_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setRendiciones(data)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.codigoDelegacion && item.numeroRecibo) {
                setReciboPublicacion({
                    codigoDelegacion: item.codigoDelegacion,
                    numeroRecibo: item.numeroRecibo,
                })
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title="Rendiciones de devolución a Ingresos Públicos"
            body={(
                <>
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={rendiciones}
                    avmr={avmr}
                    columns={[
                        { Header: 'N° VEP', accessor: 'numeroRecibo', width: '25%', Cell: ({ row }) =>  getNumeroRecibo_ObjectToIdentificador(row.original) },
                        { Header: 'Fecha de Cobro', accessor: 'fechaPago', Cell: (data) => getDateToString(data.value), width: '15%'},
                        { Header: 'Importe', accessor: 'importePago', Cell: (data) => getFormatNumber(data.value, 2), width: '20%', alignCell: 'right' },
                        { Header: 'Código de barras', accessor: 'codigoBarras', width: '40%' },

                    ]}
                    showDownloadCSV={false}
                />

                {reciboPublicacion && (
                    <ReciboPublicacionModal
                        codigoDelegacion={reciboPublicacion?.codigoDelegacion}
                        numeroRecibo={reciboPublicacion?.numeroRecibo}
                        onCancel={() => setReciboPublicacion(null)}
                    />
                )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default DevolucionRendicionIngresosPublicosGridModal
